import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notifyError } from "@web/features/diagnostics/notifyError.ts";
import { api } from "@web/lib/api.ts";

function fail(err: unknown, fallback: string) {
  notifyError(err, { fallbackCode: "SAVE_FAILED", actionLabel: fallback });
}

/** Move one-or-more tracks as a block inside a local playlist (fractional positions). */
export function useReorderLocalPlaylistTracks() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: {
      playlistId: string;
      trackIds: string[];
      overTrackId: string;
      edge: "before" | "after";
    }) => {
      const { playlistId, trackIds, overTrackId, edge } = input;
      for (let i = 0; i < trackIds.length; i++) {
        const trackId = trackIds[i]!;
        const body =
          i === 0
            ? edge === "before"
              ? { track_id: trackId, before_id: overTrackId }
              : { track_id: trackId, after_id: overTrackId }
            : { track_id: trackId, after_id: trackIds[i - 1]! };
        await api(`/api/local-playlists/${encodeURIComponent(playlistId)}/tracks/reorder`, {
          method: "PATCH",
          json: body,
        });
      }
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["tracks-infinite"] });
      void qc.invalidateQueries({ queryKey: ["local-playlists"] });
    },
    onError: (err) => fail(err, "Failed to reorder tracks"),
  });
}
